<template>
  <div>
    <v-dialog v-model="value" persistent>
      <v-card>
        <div class="text-xs-right">
          <v-btn fab @click="onClose" small flat><v-icon>close</v-icon></v-btn>
        </div>
        <v-card-text>
          <div class="form-control">
            <div class="caption">ชื่อสาขา</div>
            <input v-model="branch.name" type="text" placeholder="ชื่อสาขา" />
          </div>

          <v-radio-group v-model="branch.type" row>
            <v-radio value="Workshop" label="ศูนย์บริการ" color="primary"></v-radio>
            <v-radio value="Retail" label="ร้านอะไหล่" color="primary"></v-radio>
          </v-radio-group>

          <div class="form-control">
            <div class="caption">ที่อยู่</div>
            <textarea v-model="branch.address" placeholder="ที่อยู่" outline></textarea>
          </div>

          <div class="mb-2">
            <div class="caption">จังหวัด</div>
            <v-autocomplete
              v-model="branch.province"
              :items="provinces"
              item-text="cityName"
              :return-object="true"
              placeholder="Province"
              outline
              hide-details
            ></v-autocomplete>
          </div>

          <div class="form-control">
            <div class="caption">เบอร์โทร</div>
            <input v-model="branch.tel" type="text" placeholder="เบอร์โทร" />
            <div class="caption grey--text">
              Ex. 02-552-0961,085-055-6158
            </div>
          </div>

          <v-layout>
            <v-flex class="pr-1">
              <div class="form-control">
                <div class="caption">Latitude</div>
                <input v-model="branch.lat" type="text" placeholder="Latitude" />
              </div>
            </v-flex>
            <v-flex class="pl-1">
              <div class="form-control">
                <div class="caption">Longtitude</div>
                <input v-model="branch.long" type="text" placeholder="Longtitude" />
              </div>
            </v-flex>
          </v-layout>

          <div class="form-control">
            <div class="caption">Google Maps</div>
            <textarea v-model="branch.google_map_url" placeholder="Google Maps Link" outline></textarea>
            <div class="caption grey--text">Ex. https://maps.app.goo.gl/JvmGhAWkPhSirmGh6</div>
          </div>

          <div class="form-control">
            <div class="caption">ลิงก์</div>
            <textarea v-model="branch.website_url" placeholder="Link" outline></textarea>
            <div class="caption grey--text">Ex. https://www.google.com</div>
          </div>

          <div class="text-xs-center">
            <v-btn color="grey" outline @click="onClose">{{ $t('cancel') }}</v-btn>
            <v-btn color="primary" depressed @click="onSave">{{ $t('Save') }}</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ['value', 'currentBranch'],
  data() {
    return {
      branch: {
        name: '',
        type: 'Workshop',
        address: '',
        tel: '',
        lat: '',
        long: '',
        province: '',
        website_url: ''
      },
      provinces: [
        {
          "cityId": "CITY01",
          "cityName": "กรุงเทพมหานคร",
        },
        {
          "cityId": "CITY02",
          "cityName": "กระบี่",
        },
        {
          "cityId": "CITY03",
          "cityName": "กาญจนบุรี",
        },
        {
          "cityId": "CITY04",
          "cityName": "กาฬสินธุ์",
        },
        {
          "cityId": "CITY05",
          "cityName": "กำแพงเพชร",
        },
        {
          "cityId": "CITY06",
          "cityName": "ขอนแก่น",
        },
        {
          "cityId": "CITY07",
          "cityName": "จันทบุรี",
        },
        {
          "cityId": "CITY08",
          "cityName": "ฉะเชิงเทรา",
        },
        {
          "cityId": "CITY09",
          "cityName": "ชลบุรี",
        },
        {
          "cityId": "CITY10",
          "cityName": "ชัยนาท",
        },
        {
          "cityId": "CITY11",
          "cityName": "ชัยภูมิ",
        },
        {
          "cityId": "CITY12",
          "cityName": "ชุมพร",
        },
        {
          "cityId": "CITY13",
          "cityName": "เชียงราย",
        },
        {
          "cityId": "CITY14",
          "cityName": "เชียงใหม่",
        },
        {
          "cityId": "CITY15",
          "cityName": "ตรัง",
        },
        {
          "cityId": "CITY16",
          "cityName": "ตราด",
        },
        {
          "cityId": "CITY17",
          "cityName": "ตาก",
        },
        {
          "cityId": "CITY18",
          "cityName": "นครนายก",
        },
        {
          "cityId": "CITY19",
          "cityName": "นครปฐม",
        },
        {
          "cityId": "CITY20",
          "cityName": "นครพนม",
        },
        {
          "cityId": "CITY21",
          "cityName": "นครราชสีมา",
        },
        {
          "cityId": "CITY22",
          "cityName": "นครศรีธรรมราช",
        },
        {
          "cityId": "CITY23",
          "cityName": "นครสวรรค์",
        },
        {
          "cityId": "CITY24",
          "cityName": "นนทบุรี",
        },
        {
          "cityId": "CITY25",
          "cityName": "นราธิวาส",
        },
        {
          "cityId": "CITY26",
          "cityName": "น่าน",
        },
        {
          "cityId": "CITY27",
          "cityName": "บึงกาฬ",
        },
        {
          "cityId": "CITY28",
          "cityName": "บุรีรัมย์",
        },
        {
          "cityId": "CITY29",
          "cityName": "ปทุมธานี",
        },
        {
          "cityId": "CITY30",
          "cityName": "ประจวบคีรีขันธ์",
        },
        {
          "cityId": "CITY31",
          "cityName": "ปราจีนบุรี",
        },
        {
          "cityId": "CITY32",
          "cityName": "ปัตตานี",
        },
        {
          "cityId": "CITY33",
          "cityName": "พระนครศรีอยุธยา",
        },
        {
          "cityId": "CITY34",
          "cityName": "พะเยา",
        },
        {
          "cityId": "CITY35",
          "cityName": "พังงา",
        },
        {
          "cityId": "CITY36",
          "cityName": "พัทลุง",
        },
        {
          "cityId": "CITY37",
          "cityName": "พิจิตร",
        },
        {
          "cityId": "CITY38",
          "cityName": "พิษณุโลก",
        },
        {
          "cityId": "CITY39",
          "cityName": "เพชรบุรี",
        },
        {
          "cityId": "CITY40",
          "cityName": "เพชรบูรณ์",
        },
        {
          "cityId": "CITY41",
          "cityName": "แพร่",
        },
        {
          "cityId": "CITY42",
          "cityName": "ภูเก็ต",
        },
        {
          "cityId": "CITY43",
          "cityName": "มหาสารคาม",
        },
        {
          "cityId": "CITY44",
          "cityName": "มุกดาหาร",
        },
        {
          "cityId": "CITY45",
          "cityName": "แม่ฮ่องสอน",
        },
        {
          "cityId": "CITY46",
          "cityName": "ยโสธร",
        },
        {
          "cityId": "CITY47",
          "cityName": "ยะลา",
        },
        {
          "cityId": "CITY48",
          "cityName": "ร้อยเอ็ด",
        },
        {
          "cityId": "CITY49",
          "cityName": "ระนอง",
        },
        {
          "cityId": "CITY50",
          "cityName": "ระยอง",
        },
        {
          "cityId": "CITY51",
          "cityName": "ราชบุรี",
        },
        {
          "cityId": "CITY52",
          "cityName": "ลพบุรี",
        },
        {
          "cityId": "CITY53",
          "cityName": "ลำปาง",
        },
        {
          "cityId": "CITY54",
          "cityName": "ลำพูน",
        },
        {
          "cityId": "CITY55",
          "cityName": "เลย",
        },
        {
          "cityId": "CITY56",
          "cityName": "ศรีสะเกษ",
        },
        {
          "cityId": "CITY57",
          "cityName": "สกลนคร",
        },
        {
          "cityId": "CITY58",
          "cityName": "สงขลา",
        },
        {
          "cityId": "CITY59",
          "cityName": "สตูล",
        },
        {
          "cityId": "CITY60",
          "cityName": "สมุทรปราการ",
        },
        {
          "cityId": "CITY61",
          "cityName": "สมุทรสงคราม",
        },
        {
          "cityId": "CITY62",
          "cityName": "สมุทรสาคร",
        },
        {
          "cityId": "CITY63",
          "cityName": "สระแก้ว",
        },
        {
          "cityId": "CITY64",
          "cityName": "สระบุรี",
        },
        {
          "cityId": "CITY65",
          "cityName": "สิงห์บุรี",
        },
        {
          "cityId": "CITY66",
          "cityName": "สุโขทัย",
        },
        {
          "cityId": "CITY67",
          "cityName": "สุพรรณบุรี",
        },
        {
          "cityId": "CITY68",
          "cityName": "สุราษฎร์ธานี",
        },
        {
          "cityId": "CITY69",
          "cityName": "สุรินทร์",
        },
        {
          "cityId": "CITY70",
          "cityName": "หนองคาย",
        },
        {
          "cityId": "CITY71",
          "cityName": "หนองบัวลำภู",
        },
        {
          "cityId": "CITY72",
          "cityName": "อ่างทอง",
        },
        {
          "cityId": "CITY73",
          "cityName": "อำนาจเจริญ",
        },
        {
          "cityId": "CITY74",
          "cityName": "อุดรธานี",
        },
        {
          "cityId": "CITY75",
          "cityName": "อุตรดิตถ์",
        },
        {
          "cityId": "CITY76",
          "cityName": "อุทัยธานี",
        },
        {
          "cityId": "CITY77",
          "cityName": "อุบลราชธานี",
        }
      ]
    }
  },
  mounted() {
    if (this.currentBranch) {
      this.branch = {
        ...this.currentBranch,
        province: {
          cityId: this.currentBranch.cityid,
          cityName: this.currentBranch.city
        }
      }
    }
  },
  methods: {
    onSelectRegion(regionName) {
      this.branch.province = ''
      this.provinces = this.regionsWithProvinces[regionName] || []
    },
    onClose() {
      this.branch = {
        name: '',
        type: 'Workshop',
        address: '',
        tel: '',
        lat: '',
        long: '',
        province: '',
        website_url: ''
      }
      this.$emit('input', false)
    },
    onSave() {
      const {
        id,
        name,
        type,
        address,
        province,
        tel,
        lat,
        long,
        google_map_url,
        website_url,
      } = this.branch

      this.$emit('onSave', {
        id,
        name,
        type,
        address,
        cityid: province ? province.cityId : undefined,
        city: province ? province.cityName : undefined,
        tel,
        lat,
        long,
        google_map_url,
        website_url,
      })

      this.branch = {
        name: '',
        type: 'Workshop',
        address: '',
        tel: '',
        lat: '',
        long: '',
        province: '',
        website_url: ''
      }
      this.$emit('input', false)
    }
  },
  computed: {
    regions() {
      return Object.keys(this.regionsWithProvinces)
    }
  }
}
</script>

<style lang="scss">
  .v-select__slot {
    height: 100%!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/view/analytics/ManageBranchLocation.vue